import Document from '@/classes/Document';
import RefundApi from '@/api/refund'

export default class Refund {
  get document() {
    return this._document;
  }

  get typeRefunds() {
    return this._typeRefunds;
  }

  constructor() {
    this._typeRefunds = [
      { name: 'Defunción (1T)', type: 'defunción' },
      { name: 'Retiro (2T)', type: 'retiro' },
      { name: 'Ahorro (3T)', type: 'ahorro' },
      { name: 'Préstamos Ordinarios (4T)', type: 'prestamos_ordinarios' },
      { name: 'Préstamos Especiales (5T)', type: 'prestamos_especiales' },
      // { name: 'Ampliación de Defunción (6T)', type: 'ampliacion_defuncion' },
      { name: 'Préstamos de Autos (7T)', type: 'prestamos_autos' },
    ]

    this._document = new Document();
  }

  save = ({token_auth, rfc, email, cellphone, interbank_clabe, bank_name, concepts, document_list}) => {
    return RefundApi.save({token_auth, rfc, email, cellphone, interbank_clabe, bank_name, concepts, document_list}).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.response.message;
    })
  }
  
  reject = (token_auth, requestId) => {
    return RefundApi.reject(token_auth, requestId).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.response.message;
    })
  }

  cancel = (token_auth, requestId) => {
    return RefundApi.cancel(token_auth, requestId).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.response.message;
    })
  }

  getByRfc = (tokenAuth, rfc) => {
    return RefundApi.getByRfc(tokenAuth, rfc).then(response => {
      return response;
    }).catch(error => {
      throw error;
    })
  }

  getAll = (tokenAuth, processName) => {
    return RefundApi.getAll(tokenAuth, processName).then(response => {
      return response;
    }).catch(error => {
      throw error;
    })
  }
}